import { render, staticRenderFns } from "./examine.vue?vue&type=template&id=cfda9b8a"
import script from "./examine.vue?vue&type=script&lang=js"
export * from "./examine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../szc.cycz.cc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/szc.cycz.cc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cfda9b8a')) {
      api.createRecord('cfda9b8a', component.options)
    } else {
      api.reload('cfda9b8a', component.options)
    }
    module.hot.accept("./examine.vue?vue&type=template&id=cfda9b8a", function () {
      api.rerender('cfda9b8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customerInfo/customerContract/examine.vue"
export default component.exports